import { useCallback, useRef } from 'react';
import { useTracking } from './use-tracking';

export function useTrackingOnce() {
  const sentEventsMapRef = useRef<Map<string, boolean>>(new Map());
  const sentPageViewsMapRef = useRef<Map<string, boolean>>(new Map());
  const { trackEvent, trackPageView } = useTracking();

  const trackEventOnce = useCallback<typeof trackEvent>(
    (...args) => {
      const [name] = args;
      const eventSent = !!sentEventsMapRef.current.get(name);

      if (eventSent) {
        return;
      }

      trackEvent(...args);
      sentEventsMapRef.current.set(name, true);
    },
    [trackEvent],
  );

  const trackPageViewOnce = useCallback<typeof trackPageView>(
    (...args) => {
      const [name] = args;
      const pageViewSent = !!sentPageViewsMapRef.current.get(args[0]);

      if (pageViewSent) {
        return;
      }

      trackPageView(...args);
      sentPageViewsMapRef.current.set(name, true);
    },
    [trackPageView],
  );

  return {
    trackEventOnce,
    trackPageViewOnce,
  };
}
